import React, { useEffect } from 'react';
import './Aboutus.css';
import { Helmet } from "react-helmet";


const Aboutus = () => {
  useEffect(() => {
    document.title = "About Us - RP SMART ENERGY";
  }, []);

  return (
    <>
    <Helmet>
      <title>RP SMART ENERGY - Aboutus</title>
      <meta
        name="description"
        content="Learn how RP Smart Solar os transforming India's solar industry with reliable EPC execution, eco-solutions and dedicated services excellence."
      />
      <meta name="keywords" content="solar, industry, India's, EPC, eco-solutions , Smart Energy, RP Smart Solar, Services" />
    </Helmet>
    <div className="aboutus-container">
      <header className="about-header">
        <h1>About Us</h1>
        <p className="about-subtitle">"Smart Energy for a Brighter Tomorrow"</p>
      </header>

      <section className="about-content">
        <h2>Who We Are:</h2>
       <p>
          At <strong>RP SMART ENERGY</strong>, we are committed to delivering innovative and reliable solar and power solutions 
           that empower homes, businesses, and industries towards a sustainable future. Based in Erode, Tamil Nadu, we specialize 
           in the sales, service, and installation of a wide range of energy products including 
           <strong> Solar Power Plants, Solar Water Heaters, Solar Lights, Inverters, Batteries, Solar Fencing Systems, RO Water Purifiers, and more.</strong>
         </p>

         <p>
           With years of experience and a deep understanding of evolving energy needs, our team ensures the highest quality products 
           and end-to-end support—from consultation to after-sales service. Whether it’s a small residential setup or a large-scale 
           commercial project, RP SMART ENERGY is your trusted partner in providing cost-effective, energy-efficient, and eco-friendly solutions.
         </p>
      </section>

      <section className="key-offerings">
        <h2>Our Key Offerings</h2>
        <ul>
          <li>Solar Power Plant Solutions</li>
          <li>Solar Water Heaters (ETC & FPC)</li>
          <li>Solar Street & Garden Lights</li>
          <li>Solar Inverters & UPS Systems</li>
          <li>CCTV-Closed Circuit Television</li>
          <li>Lithium-ion & Lead-acid Batteries</li>
          <li>Solar Fencing Systems & Structures</li>
          <li>RO Water Purification Systems</li>
          <li>Battery Maintenance & Services</li>
        </ul>
      </section>

      <section className="about-content">
        <h2>Our Vision:</h2>
        <p>
           We believe in <strong>“Smart Energy for a Brighter Tomorrow”</strong>, making renewable energy accessible and affordable 
           for every customer. Our commitment to quality, timely service, and customer satisfaction has made us a preferred choice in the region.
         </p>

         <p>
          Our aim is to make solar energy simple and accessible for everyone by offering customized solutions, expert installation,
           and reliable after-sales service. We strive to build a sustainable future where every household and business can achieve
           energy independence and contribute to a greener planet.
         </p>
      </section>
    </div>
    </>
  );
};

export default Aboutus;
